module.exports = __webpack_public_path__ + "static/media/whiteAlpha.f0447690.svg";